import React from 'react';
function Yellow(props)
{
    return(
        <div className="myc">
            <p>{props.keyy} :</p>
            <p> {props.value}</p>
        </div>
    );
}
export default Yellow;